export default [{
    path: '/home',
    component: resolve => require(['@/components/base/view/main/main.vue'], resolve),
    children: [, {
        path: '/news/group',
        component: resolve => require(['@/components/base/view/news/group/group.vue'], resolve) //新闻分类管理
    }, {
        path: '/news/list',
        component: resolve => require(['@/components/base/view/news/list/list.vue'], resolve) //新闻列表
    }, {
        path: '/news/edit/:id',
        component: resolve => require(['@/components/base/view/news/edit/edit/edit.vue'], resolve) //新闻发布
    }, {
        path: '/news/info/:id',
        component: resolve => require(['@/components/base/view/news/info/info.vue'], resolve) //新闻详情
    }]
}]


// WEBPACK FOOTER //
// ./src/components/base/router/news.js